import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Button, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {getAllBlogs, getBlogs, initializeBlogPost} from '../../services/API/BlogpostAPI';
import useAuth from '../../hooks/useAuth';
import useAsyncCallWithLoader from '../../hooks/useAPICallWithLoader';
import {StatusBadge} from "../../components/StatusBadge";

const AdminBlogPage = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const [allBlogs, setAllBlogs] = useState([]);

  const fetchData = useCallback(async () => {
    const data = await getAllBlogs(auth.token);
    setAllBlogs(data);
  }, [getBlogs, setAllBlogs]);

  const onScreenOpenFetchData = useAsyncCallWithLoader(fetchData);
  
  const onAddBlogClick = async () => {
    const resp = await initializeBlogPost(auth.token)
    navigate(`/admin/blogs/${resp.data.id}`);
  }

  useEffect(() => {
    onScreenOpenFetchData();
  }, [])

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <h1 className="admin-page__title title">Blogs</h1>
      </div>
      <div className="admin-page__toolbar">
        <Button variant="outlined" className="admin-blog-list__btn-new" onClick={onAddBlogClick}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 1v12M1 7h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          New blog
        </Button>
      </div>

      <table className="admin-blog-list__table">
        <thead>
        <tr>
          <th className="col-id">#</th>
          <th className="col-title">Title</th>
          <th className="col-country">Country</th>
          <th className="col-status">Status</th>
        </tr>
        </thead>
        <tbody>
        {allBlogs.map(blog => {
          return (
            <tr key={blog.id} onClick={() => navigate(`/admin/blogs/${blog.id}`)}>
              <td className="col-id">{blog.id}</td>
              <td className="col-title">{blog.title}</td>
              <td className="col-country">{blog.country}</td>
              <td className="col-status">
                <StatusBadge status={blog.status} responsive/>
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>

      {allBlogs.length === 0 && (
        <p className="admin-blog-list__empty">No blog posts yet.</p>
      )}
    </div>
  )
}

export default AdminBlogPage
